class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');

    if (!this.button) return;

    this.button.addEventListener('click', (event) => {
      this.toggle(event);
    });
  }

  toggle(event) {
    const parentDisplay = this.closest('.parent-display');

    if (!parentDisplay) return;

    // toggle tekst (+ / -)
    this.querySelectorAll('.label-text').forEach(el => {
      el.classList.toggle('hidden');
    });

    // show hidden items
    const hiddenItems = parentDisplay.querySelectorAll('.show-more-item.hidden');

    hiddenItems.forEach(item => {
      item.classList.remove('hidden');
    });
  }
}

customElements.define('show-more-button', ShowMoreButton);
